import { writable } from "svelte/store";

class ConfirmDialogData {
	constructor() {
		this.instance = writable(null);
		this.visible = writable(false);
		this.onConfirm = null;
	}
}
export default ConfirmDialogData;

/* <ConfirmDialogView data={ConfirmDialogData} /> */
